import React, { useState } from "react";
import { Image, Layout, Menu, Avatar } from "antd";
import { useNavigate } from "react-router-dom";

export default function PersistentDrawerLeft(props) {
  let navigate = useNavigate();
  const [current, setCurrent] = useState("Sureler");

  const [collapsed, setCollapsed] = useState(false);
  const { Content, Sider } = Layout;

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  const items = [
    {
      key: "Sureler",
      label: "Sureler",
    },
    {
      key: "Ayetler",
      label: "Ayetler",
    },
    {
      key: "Esmaul-Husna",
      label: "Esmaul Husna",
    },
  ];

  return (
    <div>
      {window.location.pathname !== "/Login" ? (
        <Layout
          style={{
            minHeight: "100vh",
          }}
        >
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
          >
            <div
              style={{
                alignContent: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <Avatar
              size={120}
                src={
                  <Image
                    preview={false}
                    src={require("../../assets/kurandan_hayata_beyaz_logo.png")}
                  />
                }
              />
            </div>
            <Menu
              theme="dark"
              onClick={onClick}
              selectedKeys={[current]}
              mode="vertical"
              items={items}
              style={{ marginTop: 5 }}
            />
          </Sider>

          <Layout className="site-layout">
            <Content
              style={{
                margin: "0 16px",
              }}
            >
              <div
                className="site-layout-background"
                style={{
                  padding: 24,
                  minHeight: 360,
                }}
              >
                {props.children}
              </div>
            </Content>
          </Layout>
        </Layout>
      ) : (
        <div className="space-align-block"> {props.children} </div>
      )}
    </div>
  );
}
